import React, { createContext, useContext, useEffect, useState } from "react";
import { getExchangeRatesUsecase } from "src/api/packages/usecases/get-exchange-rates.usecase";
import { Currency } from "src/api/user/data/enums/user-currency.enum";

type Rates = Record<Currency, number>;

const defaultRates: Rates = {
  [Currency.USD]: 1,
  [Currency.EUR]: 1,
  [Currency.AUD]: 1,
  [Currency.GBP]: 1,
  [Currency.ILS]: 1,
};

const ExchangeRatesContext = createContext<Rates | null>(null);

export const ExchangeRatesProvider = ({ children }: { children: React.ReactNode }) => {
  const [rates, setRates] = useState<Rates>(defaultRates);

  const loadRates = async () => {
    const data = await getExchangeRatesUsecase();
    setRates(data);
  };

  useEffect(() => {
    void loadRates();
  }, []);

  return (
    <ExchangeRatesContext.Provider value={rates}>
      {children}
    </ExchangeRatesContext.Provider>
  );
};

export const useExchangeRates = () => {
  const ctx = useContext(ExchangeRatesContext);

  return ctx;
};
